// KDANKGM05010_契約書内容確認画面
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { StepNavigation as StepType } from '../../types/Template';
import { SetShelfInfo, ShelfInfoObj } from '../../types/FileUpload';
import FileUpload from '../../templates/FileUpload';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import SignInfo from '../../templates/SignInfo';
import { KeyValue } from '../../types/KeyValue';
import FooterConfirmationOfContractContents from '../../organisms/FooterConfirmationOfContractContents';
import LoadingModal from '../../molecules/LoadingModal';
import ContractContentConfirmHeadingArea from './ContractContentConfirmHeadingArea';

interface Props {
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  reception_cd: string;
  reception_sub_cd: string;
  ident_lv1_cd: string;
  ident_lv2_cd: string;
  ident_lv3_cd: string;
  step_navigation: StepType;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  sign_info: KeyValue[];
  guarantors_num: number;
  guarantor_info: GuarantorInfo;
  show_error_nav: boolean;
  display_status: boolean;
  is_signed: boolean;
  handleDecline: () => void;
  handleExecution: () => void;
  callApi: (function_name: string) => Promise<any>;
  is_loading: boolean;
  is_checked_contract_document: boolean;
  is_secured: boolean;
  is_unsecured: boolean;
  is_agricultural_modernization_funds: boolean;
  info_notice: string;
  is_active_decline_btn: boolean;
  is_signer: boolean;
}

const ContractContentConfirm: React.FC<Props> = ({
  step_navigation,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  looks_inactive,
  shelf_info,
  setShelfInfo,
  reception_id,
  reception_cd,
  reception_sub_cd,
  ident_lv1_cd,
  ident_lv2_cd,
  ident_lv3_cd,
  status_code,
  sign_info,
  is_signed,
  guarantors_num,
  guarantor_info,
  show_error_nav,
  display_status,
  handleDecline,
  handleExecution,
  callApi,
  is_loading,
  is_checked_contract_document,
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
  info_notice,
  is_active_decline_btn,
  is_signer,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <ContractContentConfirmHeadingArea
        status_code={status_code}
        guarantor_info={guarantor_info}
        is_signed={is_signed}
      />
      <Reception
        looks_inactive={looks_inactive}
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />
      <FileUpload
        shelf_info={shelf_info}
        setShelfInfo={setShelfInfo}
        reception={{
          reception_id: reception_id,
          reception_cd: reception_cd,
          reception_sub_cd: reception_sub_cd,
          ident_lv1_cd: ident_lv1_cd,
          ident_lv2_cd: ident_lv2_cd,
          ident_lv3_cd: ident_lv3_cd,
          status_code: status_code,
        }}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        guarantor_info={guarantor_info}
        is_secured={is_secured}
        is_unsecured={is_unsecured}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      <SignInfo sign_info={sign_info} />
      <FooterConfirmationOfContractContents
        status={status_code}
        is_staff={false}
        is_verification={true}
        reception_id={reception_id}
        is_signed={is_signed}
        handleDecline={handleDecline}
        handleExecution={handleExecution}
        is_checked_contract_document={is_checked_contract_document}
        info_notice={info_notice}
        is_active_decline_btn={is_active_decline_btn}
        is_signer={is_signer}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ContractContentConfirm;
